import { inject, Injectable, signal } from '@angular/core';
import { catchError, throwError, finalize, tap } from 'rxjs';
import { ErrorHandler } from '../utilities/error-handler/error-handler';
import { CalAngularService } from '@cvx/cal-angular';
import { AppConfig } from '../../../app/app-config.service';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private readonly authService = inject(CalAngularService);
    private readonly errorHandler = inject(ErrorHandler);

    // Service states
    private readonly _isLoading = signal(false);
    private readonly _isAdmin = signal<boolean>(false);
    private hasFetched = false;

    readonly isAdmin = this._isAdmin.asReadonly();
    readonly isLoading = this._isLoading.asReadonly();

    fetchAdminStatus(forceRefresh = false): void {
        // Skip if already fetched and not forcing refresh
        if (this.hasFetched && !forceRefresh) {
            return;
        }
        
        const adminGroup = AppConfig.settings?.adminGroup ?? 'ITEngineeringPortalContributors';

        this._isLoading.set(true);

        this.authService.isInGroup(adminGroup)
            .pipe(
                tap(() => console.log('Fetching admin status')),
                catchError((error) => {
                    console.error('Error fetching admin status:', error);
                    this.errorHandler.showError(
                        'An unexpected error happened while fetching admin status.'
                    );
                    return throwError(() => error);
                }),
                finalize(() => {
                    this._isLoading.set(false);
                })
            )
            .subscribe((isAdmin) => {
                this._isAdmin.set(isAdmin);
                this.hasFetched = true;
            }
        );
    }
}